var map = {
	"./ByteCamp-Info-dark.svg": "9MMn",
	"./ByteCamp-Info-light.svg": "IMkr",
	"./ByteCamp.svg": "Eg4c",
	"./Nanoleaf-Info-dark.svg": "HrFD",
	"./Nanoleaf-Info-light.svg": "DeP+",
	"./Nanoleaf.svg": "0boO",
	"./Robinhood-Info-dark.svg": "W0de",
	"./Robinhood-Info-light.svg": "+HD9",
	"./Robinhood.svg": "HiRD",
	"./UBCLaunchPad-Info-dark.svg": "pFuE",
	"./UBCLaunchPad-Info-light.svg": "ydf5",
	"./UBCLaunchPad.svg": "pgrO"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "p3f4";